import { Box, Button, Modal, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../../utils/viewPDF";
import ClearIcon from "@mui/icons-material/Clear";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ReviewBids = () => {
  const { tenderId } = useParams();
  const [bidData, setBidData] = useState();
  const [tender, setTender] = useState();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [reason, setReason] = useState();
  const [bidId, setBidId] = useState();
  const navigate = useNavigate();
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
    const [errors, setErrors] = useState({})
  
  const handleClose = () => {
    setReason("");
    setOpenRejectModal(false);
    setOpenApproveModal(false);
  };

  const getBidData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/bid/get-by-tender?tenderId=${tenderId}&username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setBidData(res.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const getTender = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTender(res.data);
    } catch (error) {
      console.error("Error updating tender status:", error);
    }
  };
  useEffect(() => {
    getTender();

    getBidData();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    const isEmpty = (value) => !value || value.trim?.() === "";

    if(isEmpty(reason)) newErrors.reason = "Reason is required"

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRejectBid = async () => {
    if(!validateForm()) return;
    setBtnLoading(true)
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/bid`,
        [
          {
            bidId: bidId,
            username: storedUser.username,
            status: "REJECTED",
            reason: reason,
          },
        ],
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpenRejectModal(false);
      setBidId();
      getBidData();
      setLoading(true);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false)
    }
  };

  const handleApproveBid = async () => {
    setBtnLoading(true)
    try {
      const payload = bidData.map((bid) => ({
        bidId: bid.bidId,
        username: storedUser.username,
        status: "TECHNICALLY_QUALIFIED",
      }));
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/bid`, payload, {
        headers: { Authorization: `Bearer ${storedUser.accessToken}` },
      });
      navigate(`/dashboard/view-bid/${tenderId}`);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false)
    }
  };
  return (
    <div style={{position: 'relative'}}>
      {btnLoading && <div className="loading-div"></div>}
      <Box className="dashboard-container" p={10}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : tender && bidData && bidData.filter(Boolean).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "58px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ padding: "9px", width: "240px" }}>
                    Technical Specification
                  </th>
                  <th style={{ padding: "9px", width: "240px" }}>Doc Name</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(8)].map((_, i) => (
                  <tr key={i}>
                    <td
                      style={{
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      TS{i + 1}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                        padding: "8px",
                      }}
                    >
                      {tender[`ts${i + 1}Title`] || "Not required"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bidData && bidData?.length * 200}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {bidData?.filter(Boolean).map((bid, index) => (
                      <th
                        key={index}
                        style={{ width: "200px", padding: "9px" }}
                      >
                        {bid.vendor.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[...Array(8)].map((_, i) => (
                    <tr key={i}>
                      {bidData.filter(Boolean).map((bid, j) => {
                        const docUrl = bid && bid[`ts${i + 1}`];
                        return (
                          <td
                            key={j}
                            style={{
                              borderTop: "1px solid #ccc",
                              borderRight: "1px solid #ccc",
                              height: "40px",
                            }}
                          >
                            {docUrl ? (
                              <Button
                                sx={{textDecoration: 'underline'}}
                                onClick={() => viewPDF(docUrl, storedUser)}
                              >
                                Link
                              </Button>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
              <Box
                  sx={{
                    display: "flex",
                    minWidth: `${bidData && bidData?.length * 200}px`,
                  }}
                >
                  {bidData.filter(Boolean).map((bid, i) => (
                    <Box
                      key={i}
                      sx={{
                        width: "200px",
                        textAlign: "center",
                      }}
                    >
                      <Button
                        className="btn-outlined btn-reject"
                        sx={{
                          margin: "10px 0 !important",
                          padding: "0 !important",
                          width: "100px !important",
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          setOpenRejectModal(true);
                          setBidId(bid.bidId);
                        }}
                      >
                        Reject
                      </Button>
                    </Box>
                  ))}
                </Box>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor bid for the tender
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Box sx={{ display: "flex", gap: 5 }}>
          <Button className="btn-outlined" onClick={() => navigate(`/dashboard/view-bid/${tenderId}`)}>
            Back
          </Button>
          <Button
            className="btn-contained"
            onClick={() => setOpenApproveModal(true)}
          >
            Approve
          </Button>
        </Box>
      </Box>

      <Modal
        open={openRejectModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            textAlign={"start"}
          >
            Bid Reject
          </Typography>
          <label htmlFor="reason">
            Please give feedback why reject the bid*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value)
              setErrors({...errors, reason: ""})
            }}
            rows={8}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p> }
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn-outlined btn-reject"
              onClick={handleRejectBid}
            >
              Reject
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openApproveModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <span
              style={{
                background: "#E5E5E5",
                borderRadius: "50%",
                padding: "4px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </span>
          </div>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            All the remaining bids in the shortlist will be sent further
          </Typography>
          <Box
            className="btn-container"
            sx={{
              width: "100%",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Button className="btn-contained" onClick={handleApproveBid} disabled={btnLoading}>
              {btnLoading ? "Updating..." : "Okay"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ReviewBids;
